'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

interface GalleryItemProps {
  idx?: number | string
  selected?: boolean
  onToggleSelect?: () => void
  comments?: number
  onOpenComments?: () => void
  caption?: ReactNode
  pic?: string
  gradient?: { c1: string; c2: string }
  rowSpan?: number
  onOpen?: () => void
  className?: string
}

export function GalleryItem({
  idx,
  selected,
  onToggleSelect,
  comments = 0,
  onOpenComments,
  caption,
  pic,
  gradient,
  rowSpan = 30,
  onOpen,
  className
}: GalleryItemProps) {
  const bg = gradient ? `linear-gradient(135deg, ${gradient.c1}, ${gradient.c2})` : undefined
  void rowSpan
  return (
    <div className={cx('st-gi', selected && 'selected', comments > 0 && 'has-comments', className)} onClick={onOpen}>
      {idx != null && <span className="idx">{idx}</span>}
      {pic ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img className="pic" src={pic} alt="" loading="lazy" draggable={false} />
      ) : (
        <div className="pic-fake" style={bg ? { background: bg } : undefined} />
      )}
      <button
        type="button"
        className="flag-btn"
        aria-label="Flag"
        onClick={(e) => {
          e.stopPropagation()
          onToggleSelect?.()
        }}>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="square">
          <path d="M6 4 L6 22" />
          <path d="M6 4 L18 4 L16 8 L18 12 L6 12" />
        </svg>
      </button>
      <button
        type="button"
        className="comment-btn"
        aria-label="Comments"
        onClick={(e) => {
          e.stopPropagation()
          onOpenComments?.()
        }}>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="square">
          <path d="M4 5 L20 5 L20 16 L12 16 L8 20 L8 16 L4 16 Z" />
        </svg>
        {comments > 0 && <span className="comment-count">{comments}</span>}
      </button>
      {caption && <div className="caption">{caption}</div>}
    </div>
  )
}
